import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconPencil';
/** Renders an SVG icon. */
const SvgPencil = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.789 4.167a3.985 3.985 0 0 1 5.635 0l1.409 1.409a3.985 3.985 0 0 1 0 5.635L13.745 25.3a1 1 0 0 1-.51.273L6.193 26.98a.996.996 0 0 1-1.173-1.173l1.41-7.044a1 1 0 0 1 .272-.509zm4.226 1.409a1.99 1.99 0 0 0-2.817 0l-.705.704 4.227 4.227.704-.705a1.99 1.99 0 0 0 0-2.817l-1.409-1.41Zm-.704 6.34-4.227-4.227-1.408 1.409 4.226 4.226zm-2.818 2.817-4.226-4.226-8.453 8.453 4.226 4.226zm-10.473 9.25-3.754.75.75-3.753z"
      />
    </svg>
  );
};
SvgPencil.displayName = displayName;
export default SvgPencil;
